module.exports = __webpack_public_path__ + "static/media/flying2.69b970f2.gif";